function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  className: "outline outline--stroke",
  stroke: "#c5cad1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2 27 19.1304-8",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.82605 25.4v17.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.2609 5 27.7391 18",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.174 20.6v22.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m36.4348 16.8v-6.8h3.8261v9.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.3478 35h-13.3913v8h13.3913z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.6521 35v8",
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m27.8261 24c1.5848 0 2.8696-1.3431 2.8696-3s-1.2848-3-2.8696-3-2.8696 1.3431-2.8696 3 1.2848 3 2.8696 3z",
  stroke: "#ffd200",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m17.3044 33h-7.65218v10h7.65218z",
  stroke: "#ffd200",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m9.65222 29h7.65218",
  stroke: "#ffd200",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m21.1305 6.99998v36.00002",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m2 43h44",
  stroke: "#c5cad1",
  strokeLinecap: "round"
}));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2aded0de.svg";
export { ForwardRef as ReactComponent };